import { render, staticRenderFns } from "./LookalikeDialog.vue?vue&type=template&id=69ab047a&scoped=true"
import script from "./LookalikeDialog.vue?vue&type=script&lang=js"
export * from "./LookalikeDialog.vue?vue&type=script&lang=js"
import style0 from "./LookalikeDialog.vue?vue&type=style&index=0&id=69ab047a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ab047a",
  null
  
)

export default component.exports